

































































































































































import FilterSelection from "@/components/filter/FilterSelection.vue";
import { MrfiktivPageFilterElementGen } from "@/services/mrfiktiv/v1/data-contracts";
import { ThgPageFilterElementGen } from "@/services/thg/v1/data-contracts";
import {
  FilterTypes,
  IPaginationFilterListElement,
  PaginationFilterOperationEnum
} from "@/store/modules/base-pagination.store";
import { Component, Prop, Vue } from "vue-property-decorator";
import CustomFieldValueChip from "../report/CustomFieldValueChip.vue";
import RefsUser from "../utility/RefsUser.vue";
import RefsVehicle from "../utility/RefsVehicle.vue";
import FilterCardPaginationValueField from "./FilterCardPaginationValueField.vue";
import Tooltip from "../utility/tooltip.vue";

@Component({
  components: {
    FilterSelection,
    RefsUser,
    RefsVehicle,
    CustomFieldValueChip,
    FilterCardPaginationValueField,
    Tooltip
  }
})
export default class FilterCardPagination extends Vue {
  @Prop()
  filterList!: IPaginationFilterListElement[];

  @Prop({ default: false })
  large!: boolean;

  @Prop()
  filter!: ThgPageFilterElementGen[] | MrfiktivPageFilterElementGen[];

  @Prop({ default: undefined })
  predefinedFilter!: [{ name: string; filter: ThgPageFilterElementGen[] | MrfiktivPageFilterElementGen[] }];

  /**
   * Content on search bar
   */
  @Prop()
  search!: string;

  menu = false;

  isValid = false;

  tempFilter: ThgPageFilterElementGen[] | MrfiktivPageFilterElementGen[] = [];

  get mdSizeFilter() {
    if (this.predefinedFilter) {
      return 8;
    }
    return 12;
  }

  get _filter() {
    return this.filter;
  }

  set _filter(filter: ThgPageFilterElementGen[] | MrfiktivPageFilterElementGen[]) {
    this.$emit("update:filter", filter);
  }

  get operations() {
    return Object.values(PaginationFilterOperationEnum);
  }

  setPredefinedFilter(filter: ThgPageFilterElementGen[] | MrfiktivPageFilterElementGen[]) {
    this.tempFilter.splice(0, this.tempFilter.length, ...filter);
    this.confirmFilter();
  }

  getFilterConfiguration(filter: ThgPageFilterElementGen) {
    return this.filterList.find(e => e.key === filter.key);
  }

  getOperations(item: ThgPageFilterElementGen | MrfiktivPageFilterElementGen) {
    if (this.getTypeForKey(item.key) === FilterTypes.DATE) {
      // Not equal does not work for dates in backend
      return this.operations.filter(op => op !== PaginationFilterOperationEnum.NOT_EQUAL);
    }

    return this.operations;
  }

  getIsComparatorSelection(item: ThgPageFilterElementGen | MrfiktivPageFilterElementGen) {
    return ![FilterTypes.BOOLEAN].includes(this.getTypeForKey(item.key));
  }

  getTypeInputWidthStyle(item: ThgPageFilterElementGen | MrfiktivPageFilterElementGen) {
    if (!item.key) {
      return "min-width:  calc(100% - 24px)";
    }

    const isComparatorSelection = this.getIsComparatorSelection(item);

    return `min-width: calc(40% - 24px ${isComparatorSelection ? "- 45px" : ""}) !important`;
  }

  getValueInputWidthStyle() {
    return "min-width: calc(60% - 24px) !important";
  }

  removeItem(index: number) {
    this.tempFilter.splice(index, 1);
  }

  getTypeForKey(key: string) {
    return this.getFilterForKey(key)?.type || FilterTypes.STRING;
  }

  getFilterForKey(key: string) {
    return this.filterList.find(e => e.key === key);
  }

  addFilter() {
    this.tempFilter.push({ key: "", operation: PaginationFilterOperationEnum.EQUAL, value: "" });
  }

  confirmFilter() {
    this.filter.splice(0, this.filter.length, ...this.tempFilter);
    this.$emit("confirmFilter");
    this.menu = false;
  }

  removeAll() {
    this.tempFilter.splice(0);
    this._filter.splice(0);
    this.confirmFilter();
  }

  /**
   *
   */
  initTempFilter() {
    this.tempFilter.splice(0);
    // Copy filter as new object. Otherwise if the value is changed the changes are applied immediately as the reference is the same
    this._filter.forEach(f => this.tempFilter.push({ ...f }));
  }
}
